<div class="modal-header">
    <h4 class="modal-title">{{ 'Add Containers from TOS' | translate }}</h4>
    <button class="close" type="button" aria-label="Close" [disabled]="isBusy" (click)="activeModal.close(null)">
        <span aria-hidden="true">&times;</span>
    </button>
</div>

<form autofocus [formGroup]="form" (ngSubmit)="searchForm()">
    <div class="row mt-2">
        <div class="col-sm-12 col-md-6 col-lg-3">
            <form-textbox
                labelText="{{ 'Vessel Visit Voyage' | translate }}"
                formControlName="vesselVisitVoyage"></form-textbox>
        </div>
        <div class="col-sm-12 col-md-6 col-lg-3">
            <form-textbox labelText="{{ 'Manipulation' | translate }}" formControlName="manipulationId"></form-textbox>
        </div>
        <div class="col-sm-12 col-md-6 col-lg-3">
            <form-textbox labelText="{{ 'Operator' | translate }}" formControlName="operatorId"></form-textbox>
        </div>
        <div class="col-sm-12 col-md-6 col-lg-3">
            <form-textbox labelText="{{ 'Terminal' | translate }}" formControlName="terminal"></form-textbox>
        </div>
    </div>
    <div class="row">
        <div class="col-sm-12 col-md-6 col-lg-3">
            <form-dropdown
                labelText="{{ 'Line' | translate }}"
                formControlName="line"
                [observableInput]="line$"
                [automaticPopulateWithFirstValue]="true"></form-dropdown>
        </div>
        <div class="col-sm-12 col-md-6 col-lg-3">
            <form-textbox
                labelText="{{ 'Booking' | translate }} {{ showBookingOrBLAlert ? '*' : '' }}"
                contextual="{{ showBookingOrBLAlert ? 'Booking or Bill Of Lading is mandatory' : ('' | translate) }}"
                formControlName="booking"></form-textbox>
        </div>
        <div class="col-sm-12 col-md-6 col-lg-3">
            <form-textbox
                labelText="{{ 'Bill Of Lading' | translate }} {{ showBookingOrBLAlert ? '*' : '' }}"
                contextual="{{ showBookingOrBLAlert ? 'Booking or Bill Of Lading is mandatory' : ('' | translate) }}"
                formControlName="billOfLading"></form-textbox>
        </div>
        <div class="col-sm-12 col-md-6 col-lg-3">
            <form-dropdown
                labelText="{{ 'F/E' | translate }}"
                formControlName="fe"
                codeListName="FullOrEmpty"></form-dropdown>
        </div>
    </div>
    <div class="row">
        <div class="col-sm-12 col-md-6 col-lg-3">
            <form-textbox labelText="{{ 'ISO' | translate }}" formControlName="iso"></form-textbox>
        </div>
        <div class="col-sm-12 col-md-6 col-lg-3">
            <form-textbox
                labelText="{{ 'Containers' | translate }}"
                formControlName="containers"
                contextual="{{
                    'You can search for multiple containers by entering their container numbers, separated by a comma (e.g., MEDU1234567, CMAU7654321, TCLU9876543).'
                        | translate
                }}"></form-textbox>
        </div>
        @if (manipulationId === 'VSIN' || cargoManifestId) {
            <div class="col-sm-12 col-md-6 col-lg-3">
                <form-textbox labelText="{{ 'POD' | translate }}" formControlName="pod"></form-textbox>
            </div>
        }
        @if (manipulationId === 'VSOUT') {
            <div class="col-sm-12 col-md-6 col-lg-3">
                <form-textbox labelText="{{ 'POL' | translate }}" formControlName="pol"></form-textbox>
            </div>
        }
        <div class="col">
            <div class="float-right">
                <button
                    class="btn btn-sm btn-primary mr-2"
                    type="submit"
                    kendoTooltip
                    title="{{ 'Search' | translate }}"
                    [disabled]="isBusy || !form.valid || notSameAgent() || containersEmptyForArrivalOrDeparture()">
                    <fa-icon [icon]="['fas', 'search']"></fa-icon>
                </button>
                <button
                    class="btn btn-sm btn-secondary"
                    type="button"
                    kendoTooltip
                    title="{{ 'Clear' | translate }}"
                    [disabled]="isBusy"
                    (click)="clear()">
                    <fa-icon [icon]="['fas', 'times']"></fa-icon>
                </button>
            </div>
        </div>
    </div>
</form>

<div class="row">
    <div class="col-12 pt-3">
        <kendo-grid
            class="mb-2"
            [data]="itemsGridView"
            [loading]="isBusy"
            [skip]="filter.offset"
            [pageSize]="filter.pageSize"
            [sort]="sortsArr"
            [pageable]="pagingOptions"
            [sortable]="{ allowUnsort: true }"
            [navigable]="true"
            [resizable]="true"
            [kendoGridBinding]="gridData"
            [rowClass]="rowCallback"
            [selectable]="selectableSettings"
            [kendoGridSelectBy]="selectionCallback"
            [selectedKeys]="selected"
            (selectedKeysChange)="keyChange($event)">
            <ng-template kendoGridToolbarTemplate>
                <kendo-grid-spacer></kendo-grid-spacer>
                <app-column-configurator
                    [columns]="configurableColumns"
                    [visibility]="columnConfig.visibility"
                    [order]="columnConfig.order"
                    (visibilityChange)="columnConfig.onVisibilityChange($event.columnKey, $event.visible)"
                    (allVisibilityChange)="columnConfig.setAllVisibility($event)"
                    (orderChange)="columnConfig.onOrderChange($event)"
                    (resetColumns)="columnConfig.reset()"></app-column-configurator>
            </ng-template>
            <kendo-grid-checkbox-column [width]="40" [headerClass]="'justify-content-center'">
                <ng-template kendoGridHeaderTemplate let-column let-columnIndex="columnIndex">
                    <span kendoTooltip title="{{ 'Select All' | translate }}" (click)="toggleAll()">
                        @if (isAllSelected) {
                            <fa-icon size="lg" [icon]="['far', 'check-square']"></fa-icon>
                        }
                        @if (!isAllSelected) {
                            <fa-icon size="lg" [icon]="['far', 'square']"></fa-icon>
                        }
                        @if (selected.length) {
                            <span>
                                {{ selected.length }}
                            </span>
                        }
                    </span>
                </ng-template>
            </kendo-grid-checkbox-column>
            <kendo-grid-column
                title="{{ 'Article Number' | translate }}"
                field="articleNumber"
                [width]="130"
                [hidden]="columnConfig.isHidden('articleNumber')"></kendo-grid-column>
            <kendo-grid-column
                title="{{ 'Unit Number' | translate }}"
                field="unitNumber"
                [width]="130"
                [hidden]="columnConfig.isHidden('unitNumber')"></kendo-grid-column>
            <kendo-grid-column
                title="{{ 'Last Move' | translate }}"
                field="lastMove"
                [width]="120"
                [hidden]="columnConfig.isHidden('lastMove')"></kendo-grid-column>
            <kendo-grid-column
                title="{{ 'ISO Type' | translate }}"
                field="typeIso"
                [width]="100"
                [hidden]="columnConfig.isHidden('typeIso')"></kendo-grid-column>
            <kendo-grid-column
                title="{{ 'Category' | translate }}"
                field="category"
                [width]="100"
                [hidden]="columnConfig.isHidden('category')"></kendo-grid-column>
            <kendo-grid-column
                title="{{ 'Freight Kind' | translate }}"
                field="frightKind"
                [width]="100"
                [hidden]="columnConfig.isHidden('frightKind')"></kendo-grid-column>
            <kendo-grid-column
                title="{{ 'Hazardous' | translate }}"
                field="hazardous"
                [width]="100"
                [hidden]="columnConfig.isHidden('hazardous')"></kendo-grid-column>
            <kendo-grid-column
                title="{{ 'Line Operator' | translate }}"
                field="lineOp"
                [width]="130"
                [hidden]="columnConfig.isHidden('lineOp')"></kendo-grid-column>
            <kendo-grid-column
                title="{{ 'I/B Actual Visit' | translate }}"
                field="ibActualVisit"
                [width]="130"
                [hidden]="columnConfig.isHidden('ibActualVisit')"></kendo-grid-column>
            <kendo-grid-column
                title="{{ 'O/B Actual Visit' | translate }}"
                field="obActualVisit"
                [width]="130"
                [hidden]="columnConfig.isHidden('obActualVisit')"></kendo-grid-column>
            <kendo-grid-column
                title="{{ 'V-state' | translate }}"
                field="vState"
                [width]="100"
                [hidden]="columnConfig.isHidden('vState')"></kendo-grid-column>
            <kendo-grid-column
                title="{{ 'T-state' | translate }}"
                field="tState"
                [width]="100"
                [hidden]="columnConfig.isHidden('tState')"></kendo-grid-column>
            <kendo-grid-column
                title="{{ 'Position' | translate }}"
                field="position"
                [width]="100"
                [hidden]="columnConfig.isHidden('position')"></kendo-grid-column>
            <kendo-grid-column
                title="{{ 'Cmdy' | translate }}"
                field="cmdy"
                [width]="100"
                [hidden]="columnConfig.isHidden('cmdy')"></kendo-grid-column>
            <kendo-grid-column
                title="{{ 'Booking Nbr.' | translate }}"
                field="bookingNumber"
                [width]="130"
                [hidden]="columnConfig.isHidden('bookingNumber')"></kendo-grid-column>
            <kendo-grid-column
                title="{{ 'Bill of Lading nbr' | translate }}"
                field="blNbr"
                [width]="160"
                [hidden]="columnConfig.isHidden('blNbr')"></kendo-grid-column>
            <kendo-grid-column
                title="{{ 'POD' | translate }}"
                field="portOfDischargeId"
                [width]="100"
                [hidden]="columnConfig.isHidden('portOfDischargeId')"></kendo-grid-column>
            <kendo-grid-column
                title="{{ 'Shipper' | translate }}"
                field="shipper"
                [width]="100"
                [hidden]="columnConfig.isHidden('shipper')"></kendo-grid-column>
            <kendo-grid-column
                title="{{ 'Consignee' | translate }}"
                field="consignee"
                [width]="100"
                [hidden]="columnConfig.isHidden('consignee')"></kendo-grid-column>
            <kendo-grid-column
                title="{{ 'Time in' | translate }}"
                field="timeIn"
                [width]="100"
                [hidden]="columnConfig.isHidden('timeIn')"></kendo-grid-column>
            <kendo-grid-column
                title="{{ 'Time out' | translate }}"
                field="timeOut"
                [width]="100"
                [hidden]="columnConfig.isHidden('timeOut')"></kendo-grid-column>
            <kendo-grid-column
                title="{{ 'Net Weight (kg)' | translate }}"
                field="netWeight"
                [width]="130"
                [hidden]="columnConfig.isHidden('netWeight')">
                <ng-template kendoGridCellTemplate let-dataItem>
                    {{ dataItem.netWeight || '' }}
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column
                title="{{ 'Weight (kg)' | translate }}"
                field="weight"
                [width]="130"
                [hidden]="columnConfig.isHidden('weight')"></kendo-grid-column>
            <kendo-grid-column
                title="{{ 'VGM Weight (kg)' | translate }}"
                field="vgmWeight"
                [width]="130"
                [hidden]="columnConfig.isHidden('vgmWeight')"></kendo-grid-column>
            <kendo-grid-column
                title="{{ 'Type Height' | translate }}"
                field="typeHeight"
                [width]="130"
                [hidden]="columnConfig.isHidden('typeHeight')"></kendo-grid-column>
            <kendo-grid-column
                title="{{ 'Type Length' | translate }}"
                field="typeLength"
                [width]="130"
                [hidden]="columnConfig.isHidden('typeLength')"></kendo-grid-column>
            <kendo-grid-column
                title="{{ 'Damage Severity' | translate }}"
                field="damageSeverity"
                [width]="150"
                [hidden]="columnConfig.isHidden('damageSeverity')"></kendo-grid-column>
            <kendo-grid-column
                title="{{ 'Reqs. power' | translate }}"
                field="reqsPower"
                [width]="130"
                [hidden]="columnConfig.isHidden('reqsPower')">
                <ng-template let-value kendoGridCellTemplate>
                    @if (!value.reqsPower) {
                        <fa-icon [icon]="['far', 'square']"></fa-icon>
                    }
                    @if (value.reqsPower) {
                        <fa-icon [icon]="['far', 'check-square']"></fa-icon>
                    }
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column
                title="{{ 'Stop-Vessel' | translate }}"
                field="stopVsl"
                [width]="130"
                [hidden]="columnConfig.isHidden('stopVsl')">
                <ng-template let-value kendoGridCellTemplate>
                    @if (!value.stopVsl) {
                        <fa-icon [icon]="['far', 'square']"></fa-icon>
                    }
                    @if (value.stopVsl) {
                        <fa-icon [icon]="['far', 'check-square']"></fa-icon>
                    }
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column
                title="{{ 'Reqs. power' | translate }}"
                field="stopRail"
                [width]="130"
                [hidden]="columnConfig.isHidden('stopRail')">
                <ng-template let-value kendoGridCellTemplate>
                    @if (!value.stopRail) {
                        <fa-icon [icon]="['far', 'square']"></fa-icon>
                    }
                    @if (value.stopRail) {
                        <fa-icon [icon]="['far', 'check-square']"></fa-icon>
                    }
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column
                title="{{ 'Stop-Road' | translate }}"
                field="stopRoad"
                [width]="130"
                [hidden]="columnConfig.isHidden('stopRoad')">
                <ng-template let-value kendoGridCellTemplate>
                    @if (!value.stopRoad) {
                        <fa-icon [icon]="['far', 'square']"></fa-icon>
                    }
                    @if (value.stopRoad) {
                        <fa-icon [icon]="['far', 'check-square']"></fa-icon>
                    }
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column
                title="{{ 'Hzd UNNbrs' | translate }}"
                field="unNumberId"
                [width]="130"
                [hidden]="columnConfig.isHidden('unNumberId')"></kendo-grid-column>
            <kendo-grid-column
                title="{{ 'POL' | translate }}"
                field="portOfLoadingId"
                [width]="100"
                [hidden]="columnConfig.isHidden('portOfLoadingId')"></kendo-grid-column>
            <kendo-grid-column
                title="{{ 'Seal Nbr1' | translate }}"
                field="sealNbr1"
                [width]="100"
                [hidden]="columnConfig.isHidden('sealNbr1')"></kendo-grid-column>
            <kendo-grid-column
                title="{{ 'Temperature range' | translate }} (°C)"
                [width]="130"
                [style]="{ 'text-align': 'right' }"
                [hidden]="columnConfig.isHidden('temperatureRange')">
                <ng-template let-value kendoGridCellTemplate>
                    <span>
                        @if (value.temperatureFrom) {
                            <div class="d-inline">
                                {{ 'From' | translate }}
                                {{ value.temperatureFrom | number: '1.1-1' : 'de' }}
                            </div>
                        }
                        @if (value.temperatureTo) {
                            <div class="d-inline">
                                {{ 'To' | translate }}
                                {{ value.temperatureTo | number: '1.1-1' : 'de' }}
                            </div>
                        }
                    </span>
                </ng-template>
            </kendo-grid-column>
            @if (isGetCtnMode) {
                <kendo-grid-column
                    title="{{ 'Nbr. of Packages' | translate }}"
                    field="nbrOfPackages"
                    [width]="130"
                    [hidden]="columnConfig.isHidden('nbrOfPackages')"></kendo-grid-column>
            }
            @if (isGetCtnMode) {
                <kendo-grid-column
                    title="{{ 'Pack. Type' | translate }}"
                    field="packageType"
                    [width]="130"
                    [hidden]="columnConfig.isHidden('packageType')"></kendo-grid-column>
            }
            <ng-template kendoGridNoRecordsTemplate>
                <p>{{ 'No records available' | translate }}.</p>
            </ng-template>
        </kendo-grid>
    </div>
</div>
<div class="modal-footer">
    <button
        class="btn btn-sm btn-primary mr-2"
        [disabled]="isBusy || selected.length < 1 || !yesButtonName"
        (click)="save()">
        <fa-icon [icon]="['fas', 'search']"></fa-icon>
        &nbsp;&nbsp;{{ yesButtonName }}
    </button>
    <button class="btn btn-sm btn-secondary" translate [disabled]="isBusy" (click)="activeModal.close(null)">
        <fa-icon [icon]="['fas', 'times']"></fa-icon>
        &nbsp;&nbsp;{{ 'Cancel' | translate }}
    </button>
</div>
